export default __webpack_public_path__ + "a9d435282b5318882afc471a9e9c11f2.jpg";